<!--
  ~ Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
  ~ Venelin Iliev <http://veneliniliev.com>
  -->

<div class="app-container">
  <app-side-menu #sideMenu></app-side-menu>
  <app-activities></app-activities>
  <div class="app-inner-container">
    <app-header [sideMenu]="sideMenu"></app-header>

    <ng-scrollbar class="app-main-scrollbar">
      <router-outlet></router-outlet>
    </ng-scrollbar>
  </div>
</div>
